<template>
  <TopHeader />
  <article id="page-ppt-or-pdf-to-video">
    <section class="module-banner">
      <Banner />
    </section>
    <section class="module-ppt-template">
      <PptTemplate />
    </section>
    <section class="module-ppt-to-video">
      <PptToVideo />
    </section>
    <section class="module-ppt-tools-showcase">
      <PptToolsShowcase />
    </section>
    <section class="module-data-showcase">
      <DataShowcase />
    </section>
    <section class="module-faq">
      <Faq />
    </section>
    <section class="module-start-right-now">
      <StartRightNow :handler="handleTrial" />
    </section>
    <section class="module-app-footer">
      <AppFooter />
    </section>
  </article>
</template>

<script setup lang="ts">
import AppFooter from '~/design/widgets/bottom-footer/footer-cn.vue';
import StartRightNow from '~/design/widgets/start-right-now/index.vue';
import TopHeader from '~/design/widgets/top-header/index.vue';
import Banner from './modules/ppt-banner/index.vue';
import DataShowcase from './modules/ppt-case/index.vue';
import Faq from './modules/ppt-faq/index.vue';
import PptTemplate from './modules/ppt-template/index.vue';
import PptToVideo from './modules/ppt-to-video/index.vue';
import PptToolsShowcase from './modules/ppt-tools-showcase/index.vue';

const handleTrial = () => {
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/workspace`))}`,
    );
  } else {
    location.href = '/workspace';
  }
};
</script>

<style lang="scss" scoped src="./style/pc.scss" />
<style lang="scss" scoped src="./style/mobile.scss" />
